module.exports = "/virtual-football-league/img/amblems/left/France/Fake_Lille.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/France/Fake_Lille.png
// module id = 2030
// module chunks = 4